import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { StateProvider } from "./State";
import SickReport from "./SickReport";

const SickReportEntry = function ({ initialState = {} }) {
  return (
    <StateProvider initialState={initialState}>
      <SickReport />
    </StateProvider>
  );
};

SickReportEntry.defaultProps = {
  initialState: {},
};

SickReportEntry.propTypes = {
  initialState: PropTypes.shape({}),
};

const appContainer = document.querySelector("#sickreport-v2");
if (appContainer) {
  ReactDOM.render(<SickReportEntry />, appContainer);
}

export default SickReportEntry;
